// Substring/regex patterns matched against `span.description`. String patterns
// use `String.includes`; the one regex covers Google Ads endpoints across
// regional TLDs (.co.uk, .de, ...).
export const SENTRY_IGNORED_SPAN_PATTERNS: (string | RegExp)[] = [
  // Google Analytics
  'analytics.google.com',
  'google-analytics.com',

  // Google Tag Manager
  'googletagmanager.com',

  // Google Ads — DoubleClick + adservices
  'googleadservices.com',
  'doubleclick.net',

  // Google Ads endpoints on any google.<tld>[.cctld]
  /\bgoogle\.[a-z]+(?:\.[a-z]{2,3})?\/(?:ccm|rmkt|pagead|ads)\b/i,

  // Facebook Pixel + SDK
  'facebook.com/tr',
  'facebook.net',
];

type SpanLike = {
  description?: string;
};

export const filterSentrySpan = <T extends SpanLike>(span: T): T | null => {
  const description = span.description;
  if (!description) return span;
  const isTracker = SENTRY_IGNORED_SPAN_PATTERNS.some((pattern) =>
    typeof pattern === 'string' ? description.includes(pattern) : pattern.test(description)
  );
  return isTracker ? null : span;
};
